export default __webpack_public_path__ + "src/assets/refresh.f1bdc24584e427189f35287133a09e2c.svg";